import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  value: 0,
};

export const depositNotiSlice = createSlice({
    name: 'count',
    initialState,
    reducers: {
        notiCountHandler: (state, action) => {
            state.value = action.payload;
        }
              
       },
  });

export const { notiCountHandler } = depositNotiSlice.actions
export default depositNotiSlice.reducer